import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/student-registration');
  };

  const features = [
    {
      id: 1,
      icon: "Check",
      text: "Inscription gratuite et rapide"
    },
    {
      id: 2,
      icon: "Check",
      text: "Recommandations personnalisées par IA"
    },
    {
      id: 3,
      icon: "Check",
      text: "Accès à plus de 200 écoles partenaires"
    },
    {
      id: 4,
      icon: "Check",
      text: "Support disponible 24/7"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-blue-600 to-blue-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 md:w-96 md:h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 md:w-[32rem] md:h-[32rem] bg-white rounded-full translate-x-1/2 translate-y-1/2"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
            Prêt à Découvrir Votre Avenir ?
          </h2>

          <p className="text-base md:text-lg lg:text-xl text-blue-100 max-w-3xl mx-auto mb-8 md:mb-10">
            Rejoignez plus de 15,000 étudiants qui ont trouvé leur voie grâce à CURSUS Orientation. Commencez votre parcours d'orientation dès aujourd'hui.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8 md:mb-12">
            <Button
              variant="default"
              size="lg"
              iconName="UserPlus"
              iconPosition="left"
              onClick={handleGetStarted}
              className="w-full sm:w-auto bg-white text-blue-600 hover:bg-gray-100"
            >
              Commencer Gratuitement
            </Button>

            <Button
              variant="outline"
              size="lg"
              iconName="PlayCircle"
              iconPosition="left"
              className="w-full sm:w-auto border-white text-white hover:bg-white/10"
            >
              Voir la Démo
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features?.map((feature) => (
            <div
              key={feature?.id}
              className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-5"
            >
              <div className="w-8 h-8 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={20} color="#2563EB" />
              </div>
              <span className="text-sm md:text-base text-white font-medium">
                {feature?.text}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 text-center">
          <p className="text-sm md:text-base text-blue-100">
            Plus de <span className="font-bold text-white">15,000 étudiants</span> nous font confiance
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;